export const ROOT_URL = `/`;
export const LANDING_URL = `/landing`;

export const ABOUT_YOU_URL = `/about-you`;
export const ABOUT_YOUR_LOAN_URL = `/about-your-loan`;
export const YOUR_BOUNCE_BACK_LOAN_URL = `/your-bounce-back-loan`;

export const REPAYMENT_HOLIDAY_ENTRY_URL = `/repayment-holiday/entry`;
export const REPAYMENT_HOLIDAY_ATTN_URL = `/repayment-holiday/attestation`;
export const REPAYMENT_HOLIDAY_SUMMARY_URL = `/repayment-holiday/summary`;

export const EXTEND_TERM_ENTRY_URL = `/extend-term/entry`;
export const EXTEND_TERM_ATTN_URL = `/extend-term/attestation`;
export const EXTEND_TERM_SUMMARY_URL = `/extend-term/summary`;

export const OVERPAYMENT_ENTRY_URL = `/make-overpayment/entry`;
export const OVERPAYMENT_SUMMARY_URL = `/make-overpayment/summary`;

export const THANK_YOU_URL = `/thank-you`;
export const ASSERTION_URL = `/assertion`;
export const APPENDIX_URL = `/appendix`;
export const INIT_URL = `/init`;
